// src/components/PortalButton.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import { motion } from "framer-motion";


const PortalButton = ({ label = "Enter the Space" }) => {
  const navigate = useNavigate();
  return (
    <motion.button
      whileTap={{ scale: 0.95 }}
      className="
        px-4 py-2 sm:px-6 sm:py-2 rounded-xl 
        bg-indigo-700 text-white font-semibold 
        shadow-md text-sm sm:text-base
        transition-all duration-300
        ring-2 ring-indigo-100
        hover:shadow-lg hover:scale-105 hover:ring-yellow-400
        focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:ring-offset-indigo-900
        whitespace-nowrap
      "
      onClick={() => navigate("/sanctuary")}
    >
      {label}
    </motion.button>
  );
};

export default PortalButton;
